<template>
    <b-row>
<!--      <b-col cols="6">-->
<!--        <label><b>{{$t('views.exaborganizationlead.list.orientation')}}:</b></label><br>-->
<!--        <b-form-radio-group buttons button-variant="outline-primary" id="direction" v-model="direction">-->
<!--          <b-form-radio @click="changeDirection(1)" button-variant="outline-primary" value="horizontal">{{$t('views.exaborganizationlead.list.horizontal')}}</b-form-radio>-->
<!--          <b-form-radio @click="changeDirection(2)" button-variant="outline-primary" value="vertical">{{$t('views.exaborganizationlead.list.vertical')}}</b-form-radio>-->
<!--        </b-form-radio-group>-->
<!--      </b-col>-->
      <b-col cols="6">
        <div class="form-group">
          <label for="color"
                 class="form-control-label">{{$t('views.exaborganizationlead.list.backgroundColorFunnel')}}</label><br>
          <el-color-picker v-model="backgroundColorValue"></el-color-picker>
        </div>
      </b-col>
      <b-col v-if="isLoading">
        <Loader></Loader>
      </b-col>
      <b-col v-else class="m-3 p-3 overflow-x-auto" cols="12" :style="'backgroundColor:' + backgroundColorValue">
        <vue-funnel-graph class="mb-3" :width="width" :height="height"  :labels="data.labels"
                          :values="data.values" :colors="data.colors" :direction="direction"
                          :gradient-direction="gradientDirection"
                          :animated="true" :display-percentage="false"
        ></vue-funnel-graph>
      </b-col>
  </b-row>
</template>

<script>

import { VueFunnelGraph } from 'vue-funnel-graph-js-fixed-node-sass-dep'
import ApiService from '@/utils/ApiService'
import Loader from '@/components/Dashboard/Layout/Loader.vue'

export default {
  name: 'OrganizationLeadFunnel',
  components: { Loader, VueFunnelGraph },
  props: {
    boxView: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data () {
    return {
      isLoading: true,
      data: {
        labels: [],
        values: []
      },
      subLabels: ['Otwarte', 'Zakończone sukcesem', 'Zakończone porażką'],
      backgroundColor: 'background-color: #afafaf',
      backgroundColorValue: '#afafaf',
      colors: [
        ['#42a5f5'],
        ['#81fa29'],
        ['#d51515']
      ],
      direction: 'horizontal',
      gradientDirection: 'horizontal',
      height: 300,
      width: window.innerWidth - 100
    }
  },
  created () {
    this.fetchData()
  },
  mounted () {
    window.addEventListener('resize', this.handleResize)
    const style = document.createElement('style')
    style.type = 'text/css'
    style.innerHTML = `
      .svg-funnel-js .svg-funnel-js__labels .svg-funnel-js__label .label__title {
        font-size: 12px;
        font-weight: bold;
        color: '#000000';
      }
      .svg-funnel-js:not(.svg-funnel-js--vertical) .svg-funnel-js__label {
        padding-left: 12px;
      }
    `
    document.head.appendChild(style)
    this.dynamicStyle = style
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.handleResize)
    if (this.dynamicStyle) {
      this.dynamicStyle.remove()
    }
  },
  methods: {
    async fetchData () {
      this.data = await new ApiService('e_x_a_b_organization_leads_funnel').getResults()
      this.isLoading = false
    },
    changeDirection (direction) {
      if (direction === 1) {
        this.direction = 'horizontal'
        this.gradientDirection = 'horizontal'
        this.height = 300
        this.width = window.innerWidth - 100
      } else if (direction === 2) {
        this.direction = 'vertical'
        this.gradientDirection = 'vertical'
        this.height = window.innerHeight
        this.width = Math.min(400, window.innerWidth)
      }
    },
    handleResize () {
      if (this.direction === 'horizontal') {
        this.getWidth()
      } else {
        this.width = Math.min(400, window.innerWidth)
      }
    },
    getWidth (type = 1) {
      if (type === 1) {
        if (window.innerWidth > 1600) {
          if (this.boxView) {
            this.width = 450
          } else {
            this.width = window.innerWidth - 350
          }
        } else {
          if (this.boxView) {
            this.width = 460
          } else {
            this.width = window.innerWidth - 100
          }
        }
      } else if (type === 2) {
        this.width = 300
      }
    },
    setBackgroundColor (color) {
      this.backgroundColor = 'background-color:' + color
    }
  }
}
</script>
